import SourceCategories from 'collections/sourceCategories'
import fetchOncePromise from 'libraries/fetchOncePromise'

export default fetchOncePromise(new SourceCategories());


